import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './TabNavigation.css';

const TabNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Hide navigation on certain pages
  const hideNavigationPaths = [
    '/onboarding',
    '/sport/',
    '/show-parents',
    '/voice-test',
    '/logout',
    '/skill/',
    '/drill/',
  ];

  const shouldHideNavigation = hideNavigationPaths.some(
    (path) => location.pathname === path || location.pathname.includes(path)
  );

  useEffect(() => {
    if (shouldHideNavigation) {
      document.body.classList.remove('has-tab-navigation');
    } else {
      document.body.classList.add('has-tab-navigation');
    }

    return () => {
      document.body.classList.remove('has-tab-navigation');
    };
  }, [shouldHideNavigation]);

  if (shouldHideNavigation) {
    return null;
  }

  const tabs = [
    { path: '/dashboard', label: 'Dashboard', icon: '🎯' },
    { path: '/leaderboard', label: 'Leaderboard', icon: '👑' },
    { path: '/workouts/players', label: 'Strength', icon: '💪' },
    { path: '/skills/players', label: 'Skills', icon: '✨' },
  ];

  const isActive = (path) => {
    if (path === '/dashboard') {
      return location.pathname === '/dashboard';
    }
    if (path === '/leaderboard') {
      return location.pathname === '/leaderboard';
    }
    if (path === '/workouts/players') {
      return (
        location.pathname.startsWith('/workouts') ||
        location.pathname.startsWith('/sport') ||
        location.pathname.startsWith('/workout')
      );
    }
    if (path === '/skills/players') {
      return (
        location.pathname.startsWith('/skills') ||
        location.pathname.startsWith('/skill') ||
        location.pathname.startsWith('/drill')
      );
    }
    return false;
  };

  return (
    <nav className='tab-navigation'>
      <div className='tab-container'>
        {tabs.map((tab) => (
          <button
            key={tab.path}
            className={`tab ${isActive(tab.path) ? 'active' : ''}`}
            onClick={() => navigate(tab.path)}
          >
            <span className='tab-icon'>{tab.icon}</span>
            <span className='tab-label'>{tab.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
};

export default TabNavigation;
